<template>
     <el-dialog
        title="选择用户"
        v-model="dialogVisible"
        width="40%"
        :before-close="handleClose">
        <el-form-item label="用户名/邮箱/手机:" prop="examName" >
              <el-input  v-model="examName"  autocomplete="off"></el-input>
              <el-button type="primary" @click="queryClick" class="chaxun">查询</el-button>
        </el-form-item>
        <div class="Table-Bottom">
            <el-table
                v-loading="loading"
                :header-cell-style="{background:'#F2F2F2',color:'#000', height:'40px' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                width="55">
                </el-table-column> 
                <el-table-column
                prop="username"
                label="用户名">
                </el-table-column>
                <el-table-column
                prop="email"
                label="邮箱"
                show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                prop="mobile"
                label="手机"
                show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="prev, pager, next, jumper"
                :total="total">
                </el-pagination>
             </div>
        </div>
        <div class="buttom-box">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="handleClose">返回</el-button>
        </div>
        
    </el-dialog>
</template>

<script>
import { loadAllPrivilegesUsers,savePrincipal} from '@/assets/api/user.js'

export default {
    props: ['grandpaItem'],
    components: {

    },
    data() {
        return {
            examName: '',
            dialogVisible: true,
            tableData: [
         
            ],
            total: 0,
            pageInfo: {
                page: 1,
                pageSize: 10,
            },
            listItem: []
        };
    },
    created() {
        console.log(this.grandpaItem,'最外层列表item');
        this.loadAllPrivilegesUsersClick()
    },
    mounted() {

    },
    methods: {
        queryClick(){
            this.loadAllPrivilegesUsersClick()
        },
        loadAllPrivilegesUsersClick () {
            let params = {
                content: this.examName,
                userId: JSON.parse(localStorage.getItem('user')).id,
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
            }
            loadAllPrivilegesUsers(params).then((res)=> {
                console.log(res,'列表');
                this.tableData = res.data.data.data
                this.total = res.data.data.totalCount
            }).catch((err)=> {
                console.log(err);
            })
        },
        handleSelectionChange(val) {
            this.listItem = val;
            console.log(this.listItem,val,'this.multipleSelection');
        },
        submitForm () {
            let arr = []
            for ( let item of this.listItem ) {
                arr.push(item.id)
            }
            if (!this.listItem.length) {
                this.$message({
                type: 'error',
                message: '请选择要添加的用户'
                });

            } else {
                let params = {
                    roleId: this.grandpaItem.id,
                    userIds: arr
                }
                savePrincipal(params).then((res)=> {
                    console.log(res,'新增');
                    this.handleClose()
                    this.$message({
                        type: 'success',
                        message: '新增成功'
                    });
                }).catch((err)=> {
                    console.log(err);
                })
            }
            console.log(arr,'提交');
        },
        handleClose () {
            this.$emit('addfanhui')
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.loadAllPrivilegesUsersClick()

        },
    },
};
</script>

<style scoped lang="scss">
.chaxun {
    margin-left: 14px;
}
/deep/ {
    
    .el-form-item--small .el-form-item__label {
        width: 130px;
      
    }
    .el-form-item__label {
    }
    .el-input {
        width: 120px;
    }
}
</style>
